export const countryCodesWith12HoursFormat = [
  'GB',
  'IE',
  'US',
  'CA',
  'AU',
  'NZ',
  'IN',
  'PK',
  'BD',
  'MY',
  'MT',
  'EG',
  'MX',
  'NP',
  'PH',
];

export const doesCountryUse12HoursFormat = () => countryCodesWith12HoursFormat.indexOf(navigator.language.substr(3, 5)) !== -1;
